import { Error } from "@/components/admin/error";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { DataImportProvider } from "../dataImport/DataImportProvider";
import { FeedbackButton } from "../feedback/FeedbackButton";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { AdvisorCodePrompt } from "../sales/AdvisorCodePrompt";
import { getMobileNavClearance } from "./mobileNavClearance";
import { MobileNavigation } from "./MobileNavigation";
import { PullToRefresh } from "./PullToRefresh";

export const MobileLayout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  return (
    <DataImportProvider>
      <PullToRefresh />
      <ErrorBoundary FallbackComponent={Error}>
        <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
          {children}
        </Suspense>
      </ErrorBoundary>
      <MobileNavigation />
      {/* Almikia Epic PL (TASK-061): every role, floats above the bottom nav. */}
      <FeedbackButton variant="mobile" />
      {/* Almikia Epic E3b (TASK-067): asks a clave-less asesora for her
          advisor code right after sign-in. */}
      <AdvisorCodePrompt />
      <Notification mobileOffset={{ bottom: `${getMobileNavClearance()}px` }} />
    </DataImportProvider>
  );
};
